// Isolated in its own module so tests can mock the actual navigation call
// without fighting jsdom's non-configurable window.location property.
export const navigateToDeepLink = (href: string): void => {
	window.location.href = href;
};
